import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight, Calculator } from "lucide-react";
import { SITE } from "@/lib/site";

export default function MaintenanceFinalCTA({ onCalculate }) {
  return (
    <section className="section-pad bg-br-black text-white" data-testid="maintenance-final-cta">
      <div className="container-br">
        <div className="max-w-2xl">
          <div className="br-eyebrow text-br-bronze-2">Take The Next Step</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Ready to Put Your Home on a Structured Maintenance Plan?</h2>
          <p className="mt-4 text-gray-300 leading-relaxed">
            Black Ridge Construction can help you choose the right plan, complete your baseline inspection, and keep a clear maintenance record for your property.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={onCalculate}
              className="br-btn-primary"
              data-testid="final-cta-calculator"
            >
              <Calculator size={14} /> Calculate My Plan
            </button>
            <Link to="/contact" className="br-btn-secondary" data-testid="final-cta-details">
              Request Membership Details <ArrowRight size={14} />
            </Link>
            <a href={`tel:${SITE.phoneE164}`} className="br-btn-secondary" data-testid="final-cta-call">
              <Phone size={14} /> Call Black Ridge Construction
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
